<template>
	<div class="print:hidden">
		<div class="@container bg-base my-3 max-w-5xl flex">

			<div class="grid grid-cols-1 @md:grid-cols-2 @3xl:grid-cols-4 gap-3">
				<div class="flex items-center">
					<!-- <MagnifyingGlassIcon class="w-6 h-6 mr-2" /> -->
					<input type="text"
						v-model="filter.firstName"
						class="input input-sm w-full"
						:placeholder="$t('First name')"
						@input="$emit('change', filter);"
					/>
				</div>

				<div class="">
					<input type="text"
						v-model="filter.lastName"
						class="input input-sm w-full"
						:placeholder="$t('Last name')"
						@input="$emit('change', filter);"
					/>
				</div>

				<DateSelector
					:model-value="dateOfBirthFilterValue"
					input-css-classes="input-sm"
					:placeholder="$t('Date of birth')"
					@update:model-value="(value) => updateFilter('birthdate', value)"
				/>

				<div v-if="classrooms.length > 0" class="">
					<select
						class="select select-sm w-full"
						v-model="selectedClassroomId"
						@change="onClassroomChange"
					>
						<option :value="null">{{ $t('All classrooms') }}</option>
						<option v-for="classroom in classrooms" :key="classroom.id" :value="classroom.id">
							{{ classroom.name }}
						</option>
					</select>
				</div>
			</div>

			<button v-show="!filter.isEmpty()" @click="resetFilter" type="button" class="btn btn-ghost btn-sm">{{ $t('Reset') }}</button>

		</div>
	</div>
</template>


<script lang="ts">
import {mapStores} from "pinia";
import {usePupilsStore} from "@/stores/Pupils.store";
import { XMarkIcon, MagnifyingGlassIcon } from '@heroicons/vue/24/outline';
import DateSelector from "@/components/ui/DateSelector.vue";
import { DateTime } from "luxon";
import {PupilFilterDef} from "@/stores/filters/PupilFilterDef";
import { FilterParamValue } from "@/stores/filters/FilterParamValue";

export default {

	emits: ['change', 'classroomChange'],

	props: {
		initialFilter: {
			type: PupilFilterDef,
		},
		classrooms: {
			type: Array,
			default: () => [],
		},
	},

	components: {
		XMarkIcon, MagnifyingGlassIcon,
		DateSelector,
	},

	data() {
		return {
			filter: new PupilFilterDef(),
			searchTimeout: null,
			selectedDateOfBirth: null,
			selectedClassroomId: null,
		}
	},

	computed: {
		...mapStores(usePupilsStore),

		dateOfBirthFilterValue(): Date | null {
			const values = this.filter.getParamValues('birthdate');
			if (values.length > 0) {
				return DateTime.fromSQL(values[0].id).toJSDate();
			}
			return null;
		}
	},

	created() {
		// Clone the passed filter so we don't modify it directly, but emit the changed filter instead
		if(this.initialFilter) {
			this.filter = Object.assign(
				Object.create(
					Object.getPrototypeOf(this.initialFilter)
				),
				this.initialFilter
			);
		}
	},

	methods: {

		updateFilter(param, value) {
			if(param === 'birthdate') {
				if(value instanceof Date) {
					const sqlDate = DateTime.fromJSDate(value).toSQLDate();
					this.filter.setParamValues(param, [ new FilterParamValue(sqlDate, sqlDate) ]);
				} else {
					this.filter.clearParam(param);
				}
			} else {
				this.filter.setParamValues(param, [ value ]);
			}
			this.$emit('change', this.filter);
		},

		resetFilter() {
			this.filter.clear();
			this.selectedClassroomId = null;

			this.$emit('change', this.filter);
			this.$emit('classroomChange', null);
		},

		onClassroomChange() {
			const classroom = this.classrooms.find((c: any) => c.id === this.selectedClassroomId) ?? null;

			if (classroom) {
				this.filter.setParamValues('classroomIds', [classroom.id]);
			} else {
				this.filter.clearParam('classroomIds');
			}

			this.$emit('change', this.filter);
			this.$emit('classroomChange', classroom);
		},

	}

}
</script>
